module.exports = __webpack_public_path__ + "img/24.ef597d03.png";